<template>
  <v-navigation-drawer
    :value="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    :mini-variant="false"
    app
    class="app-drawer"
    dark
    color="blue darken-3"
  >
    <v-list
      dense
      class="app-drawer"
    >
      <template v-for="item in items">
        <template v-if="can(item.role)">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            prepend-icon="mdi-settings"
            class="app-drawer-title"
            color="white"
          >
            <template v-if="item.icon" v-slot:prependIcon>
              <v-list-item-action class="app-drawer-title">
                <v-icon class="app-drawer-title">{{ item.icon }}</v-icon>
              </v-list-item-action>
            </template>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="app-drawer-title">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="(child, i) in item.children">
              <v-list-item
                v-if="canAnd(child.role)"
                :key="i"
                :to="child.link"
                link
                class="app-drawer-title"
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <v-divider
            v-else-if="item.divider"
            :key="item.divider"
            dark
          ></v-divider>
          <v-list-item
            v-else
            :key="item.text"
            :to="item.link"
            link
          >
            <v-list-item-action class="app-drawer-title">
              <v-icon class="app-drawer-title">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="app-drawer-title">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
    <!-- <template v-slot:append>
      <div class="pa-2">
        <v-btn elevation="1" tile color="blue darken-3"
        @click="logout" block class="white--text text-capitalize">
          <v-icon left color="white">mdi-logout</v-icon>
          Sair
        </v-btn>
      </div>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
import tokenServices from '@/services/util/token';
import { mapState } from 'vuex';

export default {
  data: () => ({
    items: [
      {
        icon: 'mdi-view-dashboard-variant-outline',
        text: 'Dashboard',
        heading: 'dashboard',
        link: '/dashboard',
        role: 'api_configuracao_dashboard_index',
      },
      {
        divider: true,
      },
      {
        icon: 'mdi-cogs',
        text: 'Configurações',
        model: false,
        role: [
          'api_configuracao_usuario_store',
          'api_configuracao_orgao_store',
          'api_configuracao_instituicao_store',
          'api_configuracao_perfil_store',
          'api_configuracao_configuracao_index',
        ].join('|'),
        children: [
          {
            icon: 'mdi-cog',
            text: 'Configuração',
            link: '/configuracao',
            heading: 'configuracao',
            role: [
              'api_configuracao_configuracao_index',
              'api_configuracao_configuracao_store',
            ].join('|'),
          },
          {
            icon: 'mdi-account-lock',
            text: 'Usuários',
            link: '/usuarios',
            heading: 'usuarios',
            role: [
              'api_configuracao_usuario_index',
              'api_configuracao_usuario_store',
            ].join('|'),
          },
          {
            icon: 'mdi-shield-account',
            text: 'Perfis',
            link: '/perfil',
            heading: 'perfis',
            role: [
              'api_configuracao_perfil_index',
              'api_configuracao_perfil_store',
            ].join('|'),
          },
          {
            icon: 'mdi-home-circle',
            text: 'Institiuições',
            link: '/instituicao',
            heading: 'instituições',
            role: [
              'api_configuracao_instituicao_index',
              'api_configuracao_instituicao_store',
            ].join('|'),
          },
          {
            icon: 'mdi-home-assistant',
            text: 'Órgãos',
            link: '/orgao',
            heading: 'órgãos',
            role: [
              'api_configuracao_orgao_index',
              'api_configuracao_orgao_store',
            ].join('|'),
          },
        ],
      },
      {
        icon: 'mdi-developer-board',
        text: 'Desenvolvimento',
        model: false,
        role: [
          'api_configuracao_ambiente_store',
          'api_configuracao_modulo_store',
          'api_configuracao_controlador_store',
          'api_configuracao_permissao_store',
          'api_configuracao_menu_store',
        ].join('|'),
        children: [
          {
            icon: 'mdi-api',
            text: 'Ambiente',
            link: '/ambiente',
            heading: 'ambiente',
            role: [
              'api_configuracao_ambiente_index',
              'api_configuracao_ambiente_store',
            ].join('|'),
          },
          {
            icon: 'mdi-view-module',
            text: 'Módulos',
            link: '/modulo',
            heading: 'modulos',
            role: [
              'api_configuracao_modulo_index',
              'api_configuracao_modulo_store',
            ].join('|'),
          },
          {
            icon: 'mdi-axis-arrow',
            text: 'Controlador',
            link: '/controlador',
            heading: 'controladores',
            role: [
              'api_configuracao_controlador_index',
              'api_configuracao_controlador_store',
            ].join('|'),
          },
          {
            icon: 'mdi-cloud-lock',
            text: 'Permissões',
            link: '/permissoes',
            heading: 'permissoes',
            role: [
              'api_configuracao_permissao_index',
              'api_configuracao_permissao_store',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-open',
            text: 'Menu',
            link: '/menu',
            heading: 'menu',
            role: [
              'api_configuracao_menu_index',
              'api_configuracao_menu_store',
            ].join('|'),
          },
        ],
      },
      {
        icon: 'mdi-folder-open-outline',
        text: 'Cadastros',
        model: false,
        role: [
          'api_configuracao_bairro_store',
          'api_configuracao_pessoa_store',
          'api_configuracao_logradouro_store',
        ].join('|'),
        children: [
          {
            icon: 'mdi-menu-right-outline',
            text: 'Bairros',
            link: '/bairro',
            heading: 'bairro',
            role: [
              'api_configuracao_bairro_index',
              'api_configuracao_bairro_store',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Logradouro',
            link: '/logradouro',
            heading: 'logradouro',
            role: [
              'api_configuracao_logradouro_index',
              'api_configuracao_logradouro_store',
            ].join('|'),
          },
          {
            icon: 'mdi-account-multiple',
            text: 'Pessoas',
            link: '/pessoa',
            heading: 'pessoa',
            role: [
              'api_configuracao_pessoa_index',
              'api_configuracao_pessoa_store',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Categoria Veículos',
            link: { name: 'frota.categoria_veiculo' },
            heading: 'categoria_veiculo',
            role: [
              'api_frota_categoria_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Marcas Veículos',
            link: { name: 'frota.marca' },
            heading: 'marca',
            role: [
              'api_frota_marca_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Modelo Veículos',
            link: { name: 'frota.modelo' },
            heading: 'modelo',
            role: [
              'api_frota_modelo_index',
            ].join('|'),
          },
        ],
      },
      {
        icon: 'mdi-file-document-multiple-outline',
        text: 'Frota',
        model: false,
        role: [
          'api_frota_motorista_index',
          'api_frota_veiculo_index',
          'api_frota_rota_index',
          'api_frota_contrato_index',
          'api_frota_competencia_index',
        ].join('|'),
        children: [
          {
            icon: 'mdi-menu-right-outline',
            text: 'Motorista',
            link: { name: 'frota.motorista' },
            heading: 'motorista',
            role: [
              'api_frota_motorista_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Veículos',
            link: { name: 'frota.veiculo' },
            heading: 'veiculo',
            role: [
              'api_frota_veiculo_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Rota',
            link: { name: 'frota.rota' },
            heading: 'rota',
            role: [
              'api_frota_rota_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Contrato',
            link: { name: 'frota.contrato' },
            heading: 'contrato',
            role: [
              'api_frota_contrato_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Competência',
            link: { name: 'frota.competencia' },
            heading: 'competencia',
            role: [
              'api_frota_competencia_index',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Frequência Secretaria',
            link: { name: 'frota.frequencia_secretaria' },
            heading: 'frequencia-secretaria',
            role: [
              'api_frota_motorista_index',
            ].join('|'),
          },
        ],
      },
      {
        icon: 'mdi-file-document-multiple-outline',
        text: 'Relatórios',
        model: false,
        role: [
          'api_configuracao_relatorio_usuarios',
          'api_configuracao_relatorio_bairros',
          'api_configuracao_relatorio_veiculosecretaria',
        ].join('|'),
        children: [
          // {
          //   icon: 'mdi-menu-right-outline',
          //   text: 'Bairros',
          //   link: { name: 'configuracao.relatorio.tipo', params: { tipo: 'bairro' } },
          //   heading: 'bairro',
          //   role: [
          //     'api_configuracao_relatorio_bairros',
          //   ].join('|'),
          // },
          // {
          //   icon: 'mdi-menu-right-outline',
          //   text: 'Usuários',
          //   link: { name: 'configuracao.relatorio.tipo', params: { tipo: 'usuario' } },
          //   heading: 'usuarios',
          //   role: [
          //     'api_configuracao_relatorio_usuarios',
          //   ].join('|'),
          // },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Contratos',
            link: { name: 'configuracao.relatorio.contrato' },
            heading: 'contrato',
            role: [
              'api_configuracao_relatorio_veiculosecretaria',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Veículos',
            link: { name: 'configuracao.relatorio.veiculos' },
            heading: 'veiculos',
            role: [
              'api_configuracao_relatorio_veiculosecretaria',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Veículos por Secretaria',
            link: { name: 'configuracao.relatorio.veiculo_secretaria' },
            heading: 'veiculo_secretaria',
            role: [
              'api_configuracao_relatorio_veiculosecretaria',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Veículos com Falta de Informações',
            link: { name: 'configuracao.relatorio.veiculo_ausencia_dados' },
            heading: 'veiculo_ausencia_dados',
            role: [
              'api_configuracao_relatorio_veiculosecretaria',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Motoristas sem Foto',
            link: { name: 'configuracao.relatorio.motorista_sem_foto' },
            heading: 'motorista_sem_foto',
            role: [
              'api_configuracao_relatorio_veiculosecretaria',
            ].join('|'),
          },
          {
            icon: 'mdi-menu-right-outline',
            text: 'Frequência de Veículos',
            link: { name: 'configuracao.relatorio.veiculo_frequencia' },
            heading: 'veiculo_frequencia',
            role: [
              'api_configuracao_relatorio_veiculosecretaria',
            ].join('|'),
          },
        ],
      },
      {
        icon: 'mdi-file-image-outline',
        text: 'Cadastro Imagens',
        model: false,
        role: [
          'api_configuracao_relatorio_usuarios',
        ].join('|'),
        children: [
          {
            icon: 'mdi-account-outline',
            text: 'Pessoa',
            link: { name: 'frota.captura.pessoa' },
            heading: 'captura_pessoa',
            role: [
              'api_configuracao_relatorio_usuarios',
            ].join('|'),
          },
          {
            icon: 'mdi-car-outline',
            text: 'Veículo',
            link: { name: 'frota.captura.veiculo' },
            heading: 'captura_veiculo',
            role: [
              'api_configuracao_relatorio_usuarios',
            ].join('|'),
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapState('app', ['drawer']),
  },
  methods: {
    logout() {
      this.$swal({
        title: 'Sair',
        icon: 'question',
        html: 'Deseja realmente sair?',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#D32F2F',
      })
        .then((result) => {
          if (result.value) {
            tokenServices.setToken(null);
            this.$router.push('/login');
          }
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss">
  .app-drawer {
    // background-color: #2f3337 !important;
    color: #3182CE !important;

    .theme--dark.v-icon {
      color: #BEE3F8 !important;
    }
    .v-list {
      .v-list-item--active{
        background-color:#2A4365 !important;
        // ::before {
        //   opacity: 1;
        // }
      }
    }
  }

  .app-drawer-title {
    color: #EBF8FF !important;
    &.v-list-item--active{
      // background-color: #2A4365;
      &::before{
        opacity: 0 !important;
      }
    }
  }
</style>
